<script lang="ts" setup>
import SelectInput from "@src/components/ui/inputs/SelectInput.vue";

defineEmits(["valueChanged"]);

const props = defineProps<{
    id?: string;
    label?: string;
    value?: string;
    name?: string;
    class?: string;
    bordered?: boolean;
    disabled?: boolean;
}>();
</script>

<template>
    <div class="flex flex-col">
        <label
            v-if="props.label"
            :for="props.id"
            class="heading-2 text-black/80 dark:text-white/70 w-13 mb-3"
        >
            {{ props.label }}
        </label>

        <div class="relative">
            <div class="absolute left-0 top-0">
                <slot name="startAdornment"></slot>
            </div>

            <SelectInput
                :id="props.id"
                :class="[
                    props.bordered ? 'bordered-input' : 'ringed-input',
                    props.class,
                ]"
                :disabled="props.disabled"
                :name="props.name"
                :value="props.value"
                class="text-input"
                @value-changed="(value) => $emit('valueChanged', value)"
            >
                <slot></slot>
            </SelectInput>

            <div class="absolute top-0 right-0">
                <slot name="endAdornment"></slot>
            </div>
        </div>
    </div>
</template>
